// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"tW-z","sponsoredTooltipWrapper":"uW-z","sponsoredTooltip":"vW-z","newCard":"wW-z"};